export function generateOpenstreetmapLink(coordinates: { lat: number; lon: number }) {
    return `https://www.openstreetmap.org/?mlat=${coordinates.lat}&mlon=${coordinates.lon}`;
}
